<template>
    <div>
        <b-modal v-if="openModal === true"
                 v-model="openModal"
                 :no-close-on-backdrop="true"
                 :no-close-on-esc="true"
                 :hide-header="true"
                 hide-footer=""
                 :centered="true"

        >
            <div class="text-center">
                <h3>{{t('Please wait, your application is sending')}}</h3>
            </div>
            <loading />
            <div slot="modal-footer"></div>
        </b-modal>
        <accept-action :button-class="buttonClass"
                       :buttonName="submitDate === null ? t('Send') : t('Send again')"
                       :modalText="t('Do you want to send applications to insurance?')"
                       buttonIcon="paper-plane"
                       modalIcon="paper-plane"
                       v-if="insuranceType !== null && insuranceType === 25"
                       @accepted="sendApplication()"
        />
    </div>
</template>
<script>
    import AcceptAction from '../../../core/AcceptAction';
    import Loading from '../../../core/Components/loading';

    export default {
        components: {
            AcceptAction,
            Loading
        },
        props: {
            submitDate: {
                type: String|null,
                required: false,
                default: null
            },
            insuranceType: {
                type: String|null,
                required: false,
                default: null
            },
            patientId: {
                type: Number|null,
                required: false,
                default: null
            },
            buttonClass: {
                type: String,
                default: 'badge badge-warning'
            }
        },
        methods: {
            sendApplication() {
                this.openModal = true;
                this.$store.dispatch('applications/sendApplication', this.patientId).then(res => {
                    this.openModal = false;
                    this.$emit('sent');
                }).catch(res => {
                    this.openModal = false;
                });
            },
        },
        data() {
            return {
                openModal: false
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/private/applications/send-application.vue